import { render, staticRenderFns } from "./tableCompany.vue?vue&type=template&id=19a9bb56&scoped=true"
import script from "./tableCompany.vue?vue&type=script&lang=js"
export * from "./tableCompany.vue?vue&type=script&lang=js"
import style0 from "./tableCompany.vue?vue&type=style&index=0&id=19a9bb56&prod&lang=css"
import style1 from "./tableCompany.vue?vue&type=style&index=1&id=19a9bb56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a9bb56",
  null
  
)

export default component.exports